import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'

const columns = [
    {
        label: "ID",
        field: "id",
        sort: "asc",
    },
    {
        label: "Nombre",
        field: "name",
        sort: "asc",
        width: 150,
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class RolListado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);
        this.formulario = React.createRef();

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true,
            registro: {},
            idRegistroEliminar: null
        }
    }

    componentDidMount() {
        this.cargarListado();
    }

    editarRegistro = registro => {
        this.props.history.replace({ pathname: '/rolFormulario', registro: registro });
    }

    eliminarRegistro = idRegistro => {
        this.apiRest.delete('/rol/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Registro eliminado exitosamente!');
                this.ocultarModalEliminar();
                this.cargarListado();
            }
        });
    }

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        this.apiRest.get('/rol').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
            }
        });
    }

    botonesListado = registro => [
        this.apiRest.tienePermiso('item_rol_editar') ?
            <MDBBtn className="waves-effect" size="sm" color="primary" title="Editar" onClick={() => this.editarRegistro(registro)}>
                <MDBIcon icon="far fa-edit" />
            </MDBBtn>
            : ''
        , ' ',
        this.apiRest.tienePermiso('item_rol_eliminar') ?
            <MDBBtn className="waves-effect" size="sm" color="danger" title="Eliminar" onClick={() => this.mostrarModalEliminar(registro.id)}>
                <MDBIcon icon="fas fa-times" />
            </MDBBtn>
            : ''
    ];

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    mostrarModalEliminar = idRegistro => {
        this.setState({ modalAbierto: true, idRegistroEliminar: idRegistro });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, idRegistroEliminar: null });
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Listado" breadcrumbItem="Rol" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        {
                                            this.apiRest.tienePermiso('item_rol_agregar') ?
                                                <MDBBtn className="waves-effect" color="primary" onClick={() => this.props.history.replace('/rolFormulario')}>
                                                    <MDBIcon icon="fas fa-user-plus" />{' '}
                                                    Nuevo
                                                </MDBBtn>
                                                : ''
                                        }
                                        <p />

                                        {this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAbierto} size="mm">
                    <ModalHeader>
                        Eliminar Registro
                    </ModalHeader>
                    <ModalBody>
                        Esta seguro?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.eliminarRegistro(this.state.idRegistroEliminar)}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Eliminar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}